import React, { useState } from 'react';
import { Mail, CheckCircle2, ShieldCheck } from 'lucide-react';

export const NewsletterSection: React.FC = () => {
  const [email, setEmail] = useState('');
  const [isSubscribed, setIsSubscribed] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!email || !email.includes('@')) return;
    setIsSubscribed(true);
  };

  return (
    <section id="newsletter-section" className="py-14 sm:py-18 bg-[#191975] text-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        
        <div className="w-12 h-12 rounded-2xl bg-white/10 flex items-center justify-center mx-auto mb-4 backdrop-blur-xs">
          <Mail className="w-6 h-6 text-amber-300" />
        </div>

        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold tracking-tight">
          Subscribe to Our Emails
        </h2>

        <p className="text-xs sm:text-sm text-slate-200 mt-2.5 max-w-xl mx-auto leading-relaxed">
          Subscribe to our newsletter and stay updated with Health Store offers, products and wellness updates.
        </p>

        <div className="mt-8 max-w-md mx-auto">
          {isSubscribed ? (
            <div className="bg-emerald-500/20 border border-emerald-400/40 text-emerald-200 p-4 rounded-2xl flex items-center justify-center gap-2 text-xs sm:text-sm font-bold">
              <CheckCircle2 className="w-5 h-5 text-emerald-400 shrink-0" />
              <span>Thank you for subscribing! Check your inbox for special wellness discounts.</span>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-2">
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Your email address"
                className="flex-1 bg-white text-[#172554] placeholder:text-slate-400 text-xs sm:text-sm font-medium px-4 py-3.5 rounded-xl border border-transparent focus:outline-none focus:ring-2 focus:ring-amber-300"
              />
              <button
                type="submit"
                id="newsletter-subscribe-btn"
                className="bg-amber-400 hover:bg-amber-300 text-[#191975] font-black text-xs sm:text-sm uppercase tracking-wider px-6 py-3.5 rounded-xl transition-colors shadow-md shrink-0"
              >
                SUBSCRIBE
              </button>
            </form>
          )}

          <div className="mt-4 flex items-center justify-center gap-2 text-[11px] text-slate-300 font-medium">
            <ShieldCheck className="w-3.5 h-3.5 text-emerald-400" />
            <span>We respect your privacy. Unsubscribe at any time.</span>
          </div>
        </div>

      </div>
    </section>
  );
};
